import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { industries } from '../../data/industries';
import { ArchitecturalForm } from '../ui/ArchitecturalForm';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeIndustries() {
  return <section className="on-dark bg-plum py-24 text-porcelain lg:py-32" data-id="element-226" data-mp="1pyzjuc3dmenc">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10" data-id="element-227" data-mp="1uv6h7ghpihto">
        <div className="lg:col-span-4" data-id="element-228" data-mp="1ztzw9dcn6gvy">
          <SectionHeading tone="dark" label="Industries we serve" title="Leadership across the sectors shaping today’s economy" intro="Areas we are positioned to serve. Each carries its own leadership challenges, regulatory context, and talent markets." data-id="element-229" data-mp="1zx5jso5mhapk" />
          <ArchitecturalForm variant="steps" tone="dark" className="mt-6 hidden max-w-[280px] lg:block" data-id="element-230" data-mp="ehq2pw7pzyp7" />
          <ButtonLink to="/industries" variant="outline-light" arrow className="mt-8 lg:mt-2" data-id="element-231" data-mp="1gnmso5m55a70">
            Explore industries
          </ButtonLink>
        </div>
        <ul className="grid self-start border-t border-porcelain/10 sm:grid-cols-2 sm:gap-x-10 lg:col-span-7 lg:col-start-6" data-id="element-232" data-mp="1bvlkaus3g3m9">
          {industries.map(industry => {
          const Icon = industry.icon;
          return <li key={industry.slug} className="border-b border-porcelain/10" data-id="element-233" data-mp="1zmh5va5yi2l2">
                <Link to={`/industries#${industry.slug}`} className="group flex items-center gap-4 py-5" data-id="element-234" data-mp="1zkeheukgchig">
                  <Icon className="h-5 w-5 shrink-0 text-copper-light" aria-hidden="true" data-id="element-235" data-mp="1uljsdavw5wpw" />
                  <span className="flex-1 font-display font-medium leading-snug text-porcelain/90 transition-colors duration-150 group-hover:text-porcelain" data-id="element-236" data-mp="1pqe445f0o5yn">
                    {industry.name}
                  </span>
                  <ArrowUpRightIcon className="h-4 w-4 shrink-0 text-copper-light opacity-40 transition-[opacity,transform] duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:opacity-100" aria-hidden="true" data-id="element-237" data-mp="9a1lgf2la1xa" />
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}